import { CopyHoverContent } from 'components/CopyHoverContent';
import { Typography, TypographyProps } from 'libs/ui';

export const renderCopyHover = (
  value: any,
  field?: string,
  typographyProps?: TypographyProps
) => {
  value = field ? value[field] : value;
  return (
    <CopyHoverContent value={value}>
      <Typography className="ellipsisText" title={value} {...typographyProps}>
        {value}
      </Typography>
    </CopyHoverContent>
  );
};
